export default "__VITE_ASSET__Iyr5BCgY__"